// export const api = "http://localhost:1213";
export const api = "https://e-learning-platform-q6jz.onrender.com";
